import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useContent } from '../context/ContentContext';

// Injects the Meta Pixel base snippet exactly once when a pixel_id is present in CMS content.
// Automatically fires PageView on route changes.
export default function MetaPixel() {
  const { content } = useContent();
  const location = useLocation();
  const injected = useRef(false);
  const pixelId = content?.marketing?.meta_pixel_id;

  // Inject the base fbq loader once (Meta's recommended snippet, verbatim behavior)
  useEffect(() => {
    if (!pixelId || injected.current || typeof window === 'undefined') return;
    injected.current = true;

    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');

    // <noscript> pixel fallback
    const img = document.createElement('img');
    img.height = 1; img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    img.alt = '';
    document.body.appendChild(img);
  }, [pixelId]);

  // Fire PageView on every SPA route change (after first mount, which is already tracked above)
  const firstRoute = useRef(true);
  useEffect(() => {
    if (!pixelId || !window.fbq) return;
    if (firstRoute.current) { firstRoute.current = false; return; }
    window.fbq('track', 'PageView');
  }, [location.pathname, pixelId]);

  return null;
}
